// StudentCertificateHome.jsx/// Main container: History | Create Certificate | My Templates | Template Builder

import React, { Component } from "react";
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import * as Cookies from "es-cookie";
import { Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import "./_certificateHome.scss";
import CertificateHistory        from "./certificateHistory";
import DynamicCertificateBuilder from "./DynamicCertificateBuilder";
import MyTemplates               from "./MyTemplates";
// import CreateCertificate      from "./CreateCertificate"; // kept for reference — do not delete
import CreateCertificate         from "./CreateCertifictae1";
import EmployeeIdCard            from "./EmployeeIdCard";
import BulkIdCards               from "./BulkIdCards";
import { scopeBranches, filterAuthorizedBranches, onBranchScopeChange } from "../../../utils/branchScope";

// ── GraphQL queries ───────────────────────────────────────────────────────

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data { section_id class_id branch_id exam_id }
      educationalClasses { id class }
      globalBranches { id branch_name }
      globalSections { id section_name }
    }
  }
`;

const GET_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) { id class }
  }
`;

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id branch_name
      sections { id class_id section_name stream_id }
    }
  }
`;

const GET_STREAMS = gql`
  query { getStreams { id stream } }
`;

const GET_STUDENT_DETAILS = gql`
  query($institute_id: Int) {
    getNewEducationalStudents(institute_id: $institute_id) {
      student_id student_name roll_no admission_no dob
      adhar_no pen_no admitted_date academic_year_id
      profile_image profile_image_base
      class_id class_name branch_id section_id section_name
      parent_name father_name mother_name parent_mobile student_mobile
    }
  }   
`;

const GET_CERTIFICATE_TYPES = gql`
  query {
    getCertificateTypes {
      id
      certificate_type
    }
  }
`;

const GET_ACADEMIC_YEARS = gql`
  query getAcademicYears($id: Int) {
    getAcademicYears(id: $id) {
      id
      academic_year
    }
  }
`;

const GET_CERT_STUDENT_BY_ID = gql`
  query getCertificateStudentById($institute_id: Int!, $edu_student_id: Int!) {
    getCertificateStudentById(institute_id: $institute_id, edu_student_id: $edu_student_id) {
      edu_student_id
      student_name
      student_mobile
      roll_no
      admission_no
      gender
      dob
      father_name
      father_phone
      mother_name
      mother_phone
      profile_image
      profile_image_base
      adhar_no
      pen_no
      admitted_date
      class_id
      class_name
      section_id
      section_name
      academic_year_id
      academic_year
      branch_id
      institute_id
    }
  }
`;

const GET_STUDENT_ADMISSION_DETAILS = gql`
  query($student_id: Int) {
    getIndividualAdmissionDetails(student_id: $student_id) {
      form1 {
        student_first_name
        student_last_name
        student_mobile
        date_of_birth
        gender
        student_photo
        father_name
        father_contact_no
        mother_name
        mother_contact_no
        religion
        nationality
        address
        city
        pincode
      }
    }
  }
`;

const SAVE_CERTIFICATE_TEMPLATE = gql`
  mutation saveCertificateTemplate($data: CertificateTemplateInput!) {
    saveCertificateTemplate(data: $data)
  }
`;

const DELETE_CERTIFICATE_TEMPLATE = gql`
  mutation deleteCertificateTemplate($id: Int!) {
    deleteCertificateTemplate(id: $id)
  }
`;

// UPDATE_CERTIFICATE_TEMPLATE is built dynamically in handleUpdateTemplate
// to avoid backend input-type naming issues (same pattern as generateCertificate).

const GENERATE_CERTIFICATE = gql`
  mutation generateCertificate($data: CertificateAllocationInput!) {
    generateCertificate(data: $data)
  }
`;

const FILE_UPLOAD = gql`
  mutation FileUpload($params: FileUploadInput!) {
    fileUpload(params: $params) {
      uuid
      file_url
      file_extension_type
      file_name
    }
  }
`;

const GET_CERTIFICATE_TEMPLATES = gql`
  query getCertificateTemplates($institute_id: Int!, $branch_id: Int) {
    getCertificateTemplates(institute_id: $institute_id, branch_id: $branch_id) {
      id
      template_name
      certificate_type_id
      template
      institute_id
      branch_id
    }
  }
`;

const GET_CERTIFICATE_ALLOCATIONS = gql`
  query getCertificateAllocations($institute_id: Int!) {
    getCertificateAllocations(institute_id: $institute_id) {
      edu_student_id
      certificate_type_id
    }
  }
`;

const GET_EMPLOYEES_BY_INSTITUTE = gql`
  query getEmployeesByInstitute($instituteId: Int!) {
    getEmployeesByInstitute(instituteId: $instituteId) {
      success
      data {
        id
        employee_name
        emp_email
        emp_mobile
        profile_image
        employee_type
        employee_role
        subjects
        department_name
        branch_name
        estatus
      }
    }
  }
`;


// ── Helpers ───────────────────────────────────────────────────────────────

const STREAM_CLASS_IDS = [15, 16];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));

const getCurrentAcademicYear = () => {
  const now  = new Date();
  const year = now.getMonth() >= 4 ? now.getFullYear() : now.getFullYear() - 1;
  return `${year}-${year + 1}`;
};

const generateAcademicYears = () => {
  const now  = new Date();
  const curr = now.getMonth() >= 4 ? now.getFullYear() : now.getFullYear() - 1;
  return [curr - 2, curr - 1, curr, curr + 1].map(y => `${y}-${y + 1}`);
};

// ── Main class component ──────────────────────────────────────────────────

class StudentCertificateHome extends Component {

  constructor(props) {
    super(props);
    const VALID_TABS = ['history', 'create', 'builder', 'templates'];
    const urlTab = props.match?.params?.tab;
    this.state = {
      activeTab: VALID_TABS.includes(urlTab) ? urlTab : 'history',

      // Sub-tab inside the "Certificates" tab: 'student' | 'employee'
      createSubTab: 'student',

      // Template selected via "Use Template" in MyTemplates
      templateForCreate: null,

      // Template loaded into builder via "Edit" in MyTemplates
      templateForBuilder: null,

      // Every branch the user is authorized for. The certificate/template builders
      // write a branch_id, so they must keep the full list.
      branches:   [],
      // The same list narrowed to the header's (NavbarOne) branch selection — used
      // by the ID-card screens, where branch is a filter over students/employees.
      scopedBranches: [],
      allClasses: [],
      allStreams: [],

      academicYear:   getCurrentAcademicYear(),
      academicYearId: null,
      academicYears:  [],
      branchSearch:   '0',
      classSearch:    '0',
      sectionSearch: '0',
      selectedStudent: '',

      getClasses:            [],
      getSections:           [],
      certificateTypes:      [],
      savedTemplates:        [],
      existingCertificates:  [],
      employees:             [],

      showToast: false,
      toastMsg:  '',
    };
  }

  componentDidMount() {
    this.getBranches();
    this.getClasses();
    this.getStreamsList();
    this.getCertificateTypes();
    this.getSavedTemplates();
    this.getExistingCertificates();
    this.getEmployees();
    this.fetchAcademicYearId();
    const urlTab = this.props.match?.params?.tab;
    if (!urlTab) {
      this.props.history.replace('/Certificate-Generation/history');
    }
    // Branch comes from the header (NavbarOne) — re-scope the ID-card branch list.
    this.offBranchScope = onBranchScopeChange(() => this.getBranches());
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }

  componentDidUpdate(prevProps) {
    const VALID_TABS = ['history', 'create', 'builder', 'templates'];
    const prevTab = prevProps.match?.params?.tab;
    const currTab = this.props.match?.params?.tab;
    if (currTab !== prevTab) {
      const tab = VALID_TABS.includes(currTab) ? currTab : 'history';
      this.setState({ activeTab: tab });
    }
  }

  getBranches = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_BRANCHES,
        variables: { institution_id: parseInt(Cookies.get('institutionid')) },
        fetchPolicy: 'network-only',
      });
      const all = result.data.getBranches || [];
      this.setState({
        branches: filterAuthorizedBranches(all),
        scopedBranches: scopeBranches(all),
      });
    } catch { /* ignore */ }
  };

  getClasses = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_CLASSES,
        variables: { id: 1 },
        fetchPolicy: 'network-only',
      });
      this.setState({ allClasses: result.data.getExamClasses || [] });
    } catch { /* ignore */ }
  };

  getStreamsList = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_STREAMS,
        fetchPolicy: 'network-only',
      });
      this.setState({ allStreams: result.data.getStreams || [] });
    } catch { /* ignore */ }
  };

  getCertificateTypes = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_CERTIFICATE_TYPES,
        fetchPolicy: 'network-only',
      });
      this.setState({ certificateTypes: result.data.getCertificateTypes || [] });
    } catch { /* ignore */ }
  };

  // ── Fetch saved templates from backend ──────────────────────────────

  getSavedTemplates = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_CERTIFICATE_TEMPLATES,
        variables: { institute_id: parseInt(Cookies.get('institutionid')) },
        fetchPolicy: 'network-only',
      });
      this.setState({ savedTemplates: result.data.getCertificateTemplates || [] });
    } catch { /* ignore */ }
  };

  getExistingCertificates = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_CERTIFICATE_ALLOCATIONS,
        variables: { institute_id: parseInt(Cookies.get('institutionid')) },
        fetchPolicy: 'network-only',
      });
      this.setState({ existingCertificates: result.data.getCertificateAllocations || [] });
    } catch { /* ignore */ }
  };

  // ── Fetch employees for the Employee ID Card sub-tab ─────────────────────
  getEmployees = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_EMPLOYEES_BY_INSTITUTE,
        variables: { instituteId: parseInt(Cookies.get('institutionid')) },
        fetchPolicy: 'network-only',
      });
      const list = result.data?.getEmployeesByInstitute?.data || [];
      // Active employees only (estatus 1) when the flag is present.
      this.setState({ employees: list.filter(e => e.estatus == null || String(e.estatus) === '1') });
    } catch { /* ignore */ }
  };

  // ── Save certificate template via API ────────────────────────────────

  handleSaveTemplate = async ({ templateName, certType, branchId, templateJson, certificateTypeId }) => {
    const result = await this.props.client.mutate({
      mutation: SAVE_CERTIFICATE_TEMPLATE,
      variables: {
        data: {
          template_name:        templateName,
          certificate_type_id:  String(certificateTypeId),
          template:             templateJson,
          institute_id:         parseInt(Cookies.get('institutionid')),
          branch_id:            parseInt(branchId),
          inserted_by:          parseInt(Cookies.get('id')),
        },
      },
    });
    await this.getSavedTemplates();
    return result;
  };

  // ── Update existing certificate template via API ─────────────────────

  handleUpdateTemplate = async ({ id, templateName, branchId, templateJson }) => {
    const safeStr = (s) => String(s || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const mutation = gql(`
      mutation {
        updateCertificateTemplate(id: ${parseInt(id)}, data: {
          template_name: "${safeStr(templateName)}",
          template:      "${safeStr(templateJson)}",
          branch_id:     ${parseInt(branchId)},
          updated_by:    ${parseInt(Cookies.get('id'))}
        })
      }
    `);
    const result = await this.props.client.mutate({ mutation });
    await this.getSavedTemplates();
    return result;
  };

  // ── Delete certificate template via API ──────────────────────────────

  handleDeleteCertTemplate = async (id) => {
    await this.props.client.mutate({
      mutation: DELETE_CERTIFICATE_TEMPLATE,
      variables: { id: parseInt(id) },
    });
    await this.getSavedTemplates();
  };

  // ── Generate certificate (save allocation to backend) ────────────────

  handleGenerateCertificate = async ({ edu_student_id, certificate_type_id, certificate_no, issued_date, certificate_file_base64 }) => {
    let certificateFileUrl = '';

    if (certificate_file_base64) {
      try {
        const uploadResult = await this.props.client.mutate({
          mutation: FILE_UPLOAD,
          variables: {
            params: {
              category: 'certificates',
              client_id: parseInt(Cookies.get('institutionid')),
              file: [{ img: certificate_file_base64, filename: `certificate_${edu_student_id}_${Date.now()}.png` }],
            },
          },
        });
        const fileData = uploadResult.data?.fileUpload;
        const result = Array.isArray(fileData) ? fileData[0] : fileData;
        certificateFileUrl = result?.file_url || '';
      } catch (uploadErr) {
        console.warn('[GenerateCert] fileUpload failed, continuing without file URL', uploadErr);
      }
    }

    const safeStr = (s) => String(s || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const mutation = gql(`
      mutation {
        generateCertificate(data: {
          edu_student_id:     ${parseInt(edu_student_id)},
          certificate_type_id: ${parseInt(certificate_type_id)},
          certificate_no:     "${safeStr(certificate_no)}",
          issued_date:        "${safeStr(issued_date)}",
          certificate_file:   "${safeStr(certificateFileUrl)}",
          status:             1,
          inserted_by:        ${parseInt(Cookies.get('id'))}
        })
      }
    `);
    const result = await this.props.client.mutate({ mutation });
    // Refresh existing certs so duplicate check blocks re-generation immediately
    this.getExistingCertificates();
    return result;
  };

  // ── Fetch full admission details for a selected student ─────────────

  handleFetchStudentDetails = async (studentId) => {
    try {
      const result = await this.props.client.query({
        query: GET_STUDENT_ADMISSION_DETAILS,
        variables: { student_id: parseInt(studentId) },
        fetchPolicy: 'network-only',
      });
      return result.data?.getIndividualAdmissionDetails?.form1 || null;
    } catch (err) {
      console.warn('[CertFetchStudentDetails]', err.message);
      return null;
    }
  };

  // ── Fetch current academic year ID ───────────────────────────────────

  fetchAcademicYearId = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_ACADEMIC_YEARS,
        variables: { id: parseInt(Cookies.get('institutionid')) },
        fetchPolicy: 'network-only',
      });
      const years = result.data?.getAcademicYears || [];

      // Match current year by start-year number (works for "2026-27" OR "2026-2027")
      const now = new Date();
      const targetStart = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
      const sorted = [...years].sort((a, b) => parseInt(b.academic_year) - parseInt(a.academic_year));
      const match = sorted.find(y => parseInt(y.academic_year) === targetStart) || sorted[0];

      this.setState({
        academicYears: sorted,           // sorted newest first for dropdown
        academicYearId: match ? parseInt(match.id) : null,
      });
    } catch (err) {
      console.warn('[FetchAcademicYearId]', err.message);
    }
  };

  // ── Fetch full student details for the certificate form ──────────────
  // A single call to getCertificateStudentById (reads straight from edu_students).
  // The old getCertificateAllocations lookup is gone: in the create flow the
  // duplicate check already blocks students who have a certificate of that type,
  // so that query always returned empty here — a wasted round trip.

  handleFetchStudentAllocation = async (studentId) => {
    const instId = parseInt(Cookies.get('institutionid'));
    const sId    = parseInt(studentId);

    if (!instId || isNaN(sId)) {
      console.warn('[FetchStudent] missing institute/student — aborting');
      return null;
    }

    try {
      const result = await this.props.client.query({
        query: GET_CERT_STUDENT_BY_ID,
        variables: { institute_id: instId, edu_student_id: sId },
        fetchPolicy: 'network-only',
      });
      return result.data?.getCertificateStudentById || null;
    } catch (err) {
      console.error('[FetchStudent] error:', err.message);
      return null;
    }
  };

  // ── "Use Template" callback from MyTemplates ─────────────────────────

  handleUseTemplate = (template) => {
    this.setState({ templateForCreate: template, activeTab: 'create' });
  };

  // ── "Edit" callback from MyTemplates ─────────────────────────────────

  handleEditTemplate = (template) => {
    this.setState({ templateForBuilder: template });
    this.props.history.push('/Certificate-Generation/builder');
  };

  // ── Clear template when user navigates back manually ─────────────────

  handleClearTemplate = () => {
    this.setState({ templateForCreate: null });
  };

  // ── Toast helper ─────────────────────────────────────────────────────

  showToast = (msg) => {
    this.setState({ showToast: true, toastMsg: msg });
    setTimeout(() => this.setState({ showToast: false, toastMsg: '' }), 4000);
  };

  // ── Tab render ────────────────────────────────────────────────────────

  render() {
    const { activeTab, createSubTab, templateForCreate, templateForBuilder, showToast, toastMsg } = this.state;

    const globalsProps = this.props.globals;
    if (globalsProps.loading) {
      return (
        <div className="certificate-main-container">
          <Container fluid className="px-0">
            <div className="cert-skel-wrap">
              <div className="cert-skel-tabbar">
                <span className="cert-skel cert-skel--tab" />
                <span className="cert-skel cert-skel--tab" />
                <span className="cert-skel cert-skel--tab" />
                <span className="cert-skel cert-skel--tab" />
              </div>
              <div className="cert-skel-body">
                <span className="cert-skel cert-skel--title" />
                <span className="cert-skel cert-skel--sub" />
                <div className="cert-skel-row">
                  <span className="cert-skel cert-skel--input" />
                  <span className="cert-skel cert-skel--input" />
                  <span className="cert-skel cert-skel--input" />
                  <span className="cert-skel cert-skel--input" />
                </div>
                <div className="cert-skel-grid">
                  <span className="cert-skel cert-skel--card" />
                  <span className="cert-skel cert-skel--card" />
                  <span className="cert-skel cert-skel--card" />
                  <span className="cert-skel cert-skel--card" />
                  <span className="cert-skel cert-skel--card" />
                  <span className="cert-skel cert-skel--card" />
                </div>
                <span className="cert-skel cert-skel--preview" />
              </div>
            </div>
          </Container>
        </div>
      );
    }
    if (globalsProps.error) {
      console.error('Globals error:', globalsProps.error.message);
      return null;
    }

    return (
      <div className="certificate-main-container">

        {/* Toast */}
        {showToast && (
          <div className="cert-toast cert-toast--success">
            <span className="cert-toast-icon">✓</span>
            <span className="cert-toast-text">{toastMsg}</span>
            <button className="cert-toast-close" onClick={() => this.setState({ showToast: false })}>×</button>
          </div>
        )}

        {/* Tab card — expense module design */}
        <Container fluid className="px-0">
          <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>

            {/* Sub-header with nav tabs — expense module style */}
            <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px" }}>
              <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                {[
                  { key: "history",   label: "Dashboard",          icon: "fal fa-tachometer-alt" },
                  { key: "create",    label: "Certificates",       icon: "fal fa-file-certificate" },
                  { key: "templates", label: "Templates",          icon: "fal fa-layer-group" },
                  { key: "builder",   label: "Template Builder",   icon: "fal fa-drafting-compass" },
                ].map(({ key, label, icon }) => {
                  const isActive = activeTab === key;
                  return (
                    <li className="nav-item" key={key}>
                      <a
                        className={`nav-link ${isActive ? "active" : ""}`}
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.history.push(`/Certificate-Generation/${key}`);
                          if (key !== "builder") this.setState({ templateForBuilder: null });
                        }}
                        style={{
                          cursor: "pointer",
                          fontWeight: 700,
                          fontSize: 14,
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "12px 20px",
                          color: isActive ? "#6366f1" : "#4b5563",
                          background: isActive ? "#fff" : "transparent",
                          borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                          borderWidth: "1.5px",
                          borderBottomWidth: isActive ? "2px" : "1.5px",
                          borderRadius: "10px 10px 0 0",
                          transition: "all 0.15s ease",
                          marginBottom: "-1.5px",
                          textDecoration: "none",
                        }}
                      >
                        <i className={icon} />
                        {label}
                        {key === "create" && templateForCreate && (
                          <span className="cert-tab-dot" />
                        )}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Content panel */}
            <div style={{ padding: "28px" }}>
              {activeTab === "history" && (
                <CertificateHistory
                  hideHeader={true}
                  onBack={() => this.setState({ activeTab: "create" })}
                  branches={this.state.branches}
                  certificateTypes={this.state.certificateTypes}
                />
              )}
              {activeTab === "create" && (
                <>
                  {/* Sub-tabs: Student Certificate · Employee ID Card */}
                  <div style={{ display: "flex", gap: 8, marginBottom: 22, borderBottom: "1.5px solid #e2e8f0" }}>
                    {[
                      { key: "student",  label: "Student Certificate", icon: "fal fa-user-graduate" },
                      { key: "bulkid",   label: "Bulk ID Cards",        icon: "fal fa-id-card" },
                      { key: "employee", label: "Employee ID Card",    icon: "fal fa-id-badge" },
                    ].map(({ key, label, icon }) => {
                      const isActive = createSubTab === key;
                      return (
                        <button
                          key={key}
                          type="button"
                          onClick={() => this.setState({ createSubTab: key })}
                          style={{
                            display: "flex", alignItems: "center", gap: 8,
                            padding: "10px 18px", fontWeight: 700, fontSize: 13.5,
                            cursor: "pointer", background: "transparent", border: "none",
                            color: isActive ? "#6366f1" : "#6b7280",
                            borderBottom: isActive ? "2.5px solid #6366f1" : "2.5px solid transparent",
                            marginBottom: "-1.5px", transition: "all 0.15s",
                          }}
                        >
                          <i className={icon} /> {label}
                        </button>
                      );
                    })}
                  </div>

                  {createSubTab === "student" && (
                    <CreateCertificate
                      savedTemplates={this.state.savedTemplates}
                      certificateTypes={this.state.certificateTypes}
                      existingCertificates={this.state.existingCertificates}
                      deleteTemplate={this.handleDeleteCertTemplate}
                      onGenerateCertificate={this.handleGenerateCertificate}
                      branches={this.state.branches}
                      streams={this.state.allStreams}
                      allClasses={this.props.globals.globals?.educationalClasses || this.state.allClasses}
                      students={this.props.getNewEducationalStudents?.getNewEducationalStudents || []}
                      academicYears={this.state.academicYears}
                      fetchStudentDetails={this.handleFetchStudentDetails}
                      fetchStudentAllocation={this.handleFetchStudentAllocation}
                    />
                  )}

                  {createSubTab === "bulkid" && (
                    <BulkIdCards
                      branches={this.state.scopedBranches}
                      streams={this.state.allStreams}
                      allClasses={this.props.globals.globals?.educationalClasses || this.state.allClasses}
                      students={this.props.getNewEducationalStudents?.getNewEducationalStudents || []}
                      savedTemplates={this.state.savedTemplates}
                      academicYears={this.state.academicYears}
                      certificateTypes={this.state.certificateTypes}
                      onGenerateCertificate={this.handleGenerateCertificate}
                    />
                  )}

                  {createSubTab === "employee" && (
                    <EmployeeIdCard
                      employees={this.state.employees}
                      branches={this.state.scopedBranches}
                      savedTemplates={this.state.savedTemplates}
                    />
                  )}
                </>
              )}    
              {activeTab === "templates" && (
                <MyTemplates
                  savedTemplates={this.state.savedTemplates}
                  onDeleteTemplate={this.handleDeleteCertTemplate}
                  onEditTemplate={this.handleEditTemplate}
                />
              )}      
              {activeTab === "builder" && (
                <DynamicCertificateBuilder
                  key={templateForBuilder ? templateForBuilder.id : "new"}
                  initialTemplate={templateForBuilder}
                  branches={this.state.branches}
                  certificateTypes={this.state.certificateTypes}
                  savedTemplates={this.state.savedTemplates}
                  saveTemplate={this.handleSaveTemplate}
                  updateTemplate={this.handleUpdateTemplate}
                  onTemplateSaved={() => {
                    const wasEditing = !!templateForBuilder;
                    this.getSavedTemplates();
                    this.showToast(wasEditing ? "Template updated successfully!" : "Template saved successfully!");
                    // Clear the edited template so re-opening the builder starts fresh
                    // (navigating via history.push skips the tab-click cleanup).
                    this.setState({ templateForBuilder: null });
                    this.props.history.push('/Certificate-Generation/templates');
                  }}
                />
              )}
            </div>

          </div>
        </Container>

      </div>
    );
  }
}

export default withRouter(withApollo(compose(
  graphql(FETCH_GLOBALS, {
    options: () => ({
      variables: { institution_id: parseInt(Cookies.get('institutionid')) },
    }),
    name: 'globals',
  }),
  graphql(GET_STUDENT_DETAILS, {
    options: () => ({
      variables: { institute_id: parseInt(Cookies.get('institutionid')) },
    }),
    name: 'getNewEducationalStudents',
  }),
)(StudentCertificateHome)));
